/**
 * Prueft den Von/Bis-Zeitraum der Seite "Aktivitaeten", bevor die Seite ihn an den Server schickt (Zweig-Fix
 * zu Phase 1, Ruling 36). Der Server antwortet auf `von > bis` mit 400 - richtig fuer Direktaufrufe, aber fuer
 * die Seite ein Eingabezustand, kein Ausfall: der Nutzer hat nur zwei Daten vertauscht oder tippt gerade.
 *
 * - `ok`: keine oder eine Grenze, oder `von` <= `bis` - die Seite darf laden.
 * - `vertauscht`: beide vollstaendig, `von` liegt nach `bis` - die Seite laedt nicht und sagt es an den
 *   Datumsfeldern.
 * - `unfertig`: eine Grenze ist kein vollstaendiges `JJJJ-MM-TT` mit Jahr ab 1000. Ein Datumsfeld meldet beim
 *   Tippen des Jahres jede Ziffer als Datum (0002, 0020, 0202, 2026, siehe `state/adresse.ts#alsKalendertag`);
 *   ein solcher Zwischenstand darf weder laden noch einen Hinweis aufblitzen lassen. Verglichen wird nicht.
 *
 * Reine Textrechnung: `JJJJ-MM-TT` mit vierstelligem Jahr ordnet sich als Text wie als Datum.
 */
export type ZeitraumStand = "ok" | "unfertig" | "vertauscht";

/** Das kleinste Jahr, ab dem eine Grenze als fertig getippt gilt. */
const ERSTES_FERTIGES_JAHR = 1000;

function istFertig(tag: string): boolean {
  const teile = tag.match(/^(\d{4})-\d{2}-\d{2}$/);
  return teile !== null && Number(teile[1]) >= ERSTES_FERTIGES_JAHR;
}

/** Leer, `null` und `undefined` gelten alle als "nicht gesetzt" (`DatumsBereichFilter` meldet "" fuer ein geleertes Feld). */
export function zeitraumPruefen(von: string | null | undefined, bis: string | null | undefined): ZeitraumStand {
  if (von && !istFertig(von)) return "unfertig";
  if (bis && !istFertig(bis)) return "unfertig";
  if (von && bis && von > bis) return "vertauscht";
  return "ok";
}
